/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const card = {
    py: 6,
    px: 4,
    backgroundColor: 'white',
    rounded: 'base',
    boxShadow: 'base'
}

const cardBordered = {
    ...card,
    px: [4, 4, 5, 6],
    border: '1px solid',
    borderColor: 'gray.50'
}

const checkoutCard = {
    px: {base: 4, lg: 6, xl: 8},
    py: null,
    rounded: 'none',
    boxShadow: 'none'
}

const checkoutLogo = {
    px: 1,
    py: 1,
    boxShadow: 'none',
    height: 6,
    width: 'auto'
}

export default {
    card,

    cardBordered,

    checkoutCard,
    checkoutLogo,

    ccIcon: {
        width: '34px',
        height: '22px'
    },

    discountedPrice: {
        background: 'stokkeBlue.mid'
    },

    page: {
        px: {base: 4, lg: 6, xl: 8}
    },

    // link style for elements inside link or button
    insideLink: {
        bgGradient: 'linear-gradient(to bottom, transparent 50%, stokkeCore.black 50%)',
        backgroundSize: '100% 210%',
        transition: '.5s',
        color: 'stokkeCore.black',
        paddingBottom: 'calc(var(--chakra-space-linkUnderlineOffset) / 2)',
        textDecoration: 'underline',
        textUnderlineOffset: 'var(--chakra-space-linkUnderlineOffset)',
        minWidth: '1em',
        width: 'max-content',
        '@media(pointer: fine)': {
            'a:hover &, button:hover &': {
                backgroundPosition: '0 97%',
                color: 'stokkeCore.white',
                textDecoration: 'none',
                textDecorationColor: 'stokkeCore.black',
                _disabled: {
                    color: 'stokkeCore.mid'
                }
            },
            'a:active &, button:active &': {
                bg: 'stokkeCore.black',
                color: 'stokkeCore.white',
                textDecoration: 'none'
            }
        },
        [['[disabled]', '[aria-disabled=true]', '[data-disabled]']
            .flatMap((selector) => [`a${selector} &, button${selector} &`])
            .join(', ')]: {
            color: 'stokkeGray.mid'
        }
    }
}
